var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPremiumPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_938_12027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.962 71.1685V64.7011H19.4294V58.2337H38.8316V64.7011H32.3642V71.1685H25.8968V77.6359H19.4294V90.5707H32.3642V84.1033H38.8316V77.6359H45.299V71.1685H51.7664V90.5707H45.299V97.0381H38.8316V103.533H6.46745V71.1685H12.962Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2988 77.6357H38.8314V84.1031H32.364V90.5705H19.4293V77.6357H25.8967V71.1683H32.364V64.701H45.2988V77.6357Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6631 84.1031H71.1685V90.5705H64.7011V97.0379H58.2337V77.6357H64.7011V71.1683H71.1685V64.701H77.6631V84.1031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6632 58.2337H84.1306V64.7011H77.6632V58.2337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1305 51.7663H90.5979V58.2337H84.1305V51.7663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1958 45.299H84.1306V51.7664H71.1958V45.299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5975 45.299H97.0649V51.7664H90.5975V45.299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7663 38.8315V32.3369H58.2337V25.8695H64.7011V38.8315H71.1685V45.2989H64.7011V51.7662H58.2337V58.2336H51.7663V64.701H45.2989V58.2336H38.8315V51.7662H12.9619V45.2989H19.4293V38.8315H25.8967V32.3369H45.2989V38.8315H51.7663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1305 38.8314H90.5979V45.2988H84.1305V38.8314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0651 38.8314H90.5977V25.8694H84.1303V19.402H71.1683V12.9346H64.701V6.46725H103.532V45.2988H97.0651V38.8314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.299 25.8695H51.7664V32.3369H45.299V25.8695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6632 25.8695H84.1306V32.3369H77.6632V25.8695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7662 19.4021H58.2336V25.8695H51.7662V19.4021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7011 19.4021H71.1685V25.8695H64.7011V19.4021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2335 12.9349H64.7009V19.4022H58.2335V12.9349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49459 103.533H38.8315V110H6.49459V103.533Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8314 97.0381H45.2988V103.505H38.8314V97.0381Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2335 97.0381H64.7009V103.505H58.2335V97.0381Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7665 90.5708V71.1686H45.2991V64.7012H51.7665V58.2338H58.2339V51.7664H64.7013V45.299H71.1687V51.7664H84.1306V58.2338H77.6632V64.7012H71.1687V71.1686H64.7013V77.636H58.2339V97.0382H45.2991V90.5708H51.7665Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7011 90.5707H71.1685V97.0381H64.7011V90.5707Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1957 84.1032H77.6631V90.5706H71.1957V84.1032Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.00010252 71.1686H6.46729V103.506H-0.00010252V71.1686Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6632 64.701H84.1306V84.1031H77.6632V64.701Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49453 64.701H12.9619V71.1683H6.49453V64.701Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8314 58.2337H45.2988V64.7011H38.8314V58.2337Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1305 58.2337H90.5979V64.7011H84.1305V58.2337Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8315 51.7663V58.2337H19.4294V64.7011H12.962V51.7663H38.8315Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5975 51.7663H97.0649V58.2337H90.5975V51.7663Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49453 45.299H12.9619V51.7664H6.49453V45.299Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1305 45.299H90.5979V51.7664H84.1305V45.299Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0651 45.299H103.532V51.7664H97.0651V45.299Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9618 38.8314H19.4292V45.2988H12.9618V38.8314Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5975 38.8314H97.0649V45.2988H90.5975V38.8314Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4293 32.3369H25.8967V38.8043H19.4293V32.3369Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.299 32.3369H51.7664V38.8043H45.299V32.3369Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7012 38.8314V25.8695H71.1686V19.4021H84.1305V25.8695H77.6631V32.3369H84.1305V25.8695H90.5979V38.8314H84.1305V45.2988H71.1686V38.8314H64.7012Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.533 6.46725H110V45.2988H103.533V6.46725Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8967 25.8695H45.2988V32.3369H25.8967V25.8695Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7662 25.8695H58.2336V32.3369H51.7662V25.8695Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.299 19.4021H51.7664V25.8695H45.299V19.4021Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2335 19.4021H64.7009V25.8695H58.2335V19.4021Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7662 12.9349H58.2336V19.4022H51.7662V12.9349Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7011 12.9349H71.1685V19.4022H64.7011V12.9349Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2335 6.46725H64.7009V12.9346H58.2335V6.46725Z",
    fill: "#0E151D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.701 0H103.532V6.46739H64.701V0Z",
    fill: "#0E151D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_938_12027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white",
    transform: "matrix(-1 0 0 1 110 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumPlan);
export default __webpack_public_path__ + "static/media/premiumPlan.c3efa74de3d3ee107040ffbe03e104e5.svg";
export { ForwardRef as ReactComponent };